import React from "react";
import Form from "react-bootstrap/Form";
import ClockIcon from "./svg/ClockIcon";
import styled from "styled-components";

export default function InputTimeSmall({ className, ...params }) {
  return (
    <TimeSmall className={`input_time_small w-100 position-relative ${className ? "is-invalid" : ""}`}>
      <Form.Control {...params} type="time" className={className} />
      <ClockIcon
        className={`position-absolute top-50 translate-middle-y pe-none ${className && className.includes('is-invalid') ? 'd-none' : ''}`}
      />


    </TimeSmall>
  );
}

const TimeSmall = styled.div`
    input[type="time"]::-webkit-calendar-picker-indicator {
        background: none;
        margin-left: 0;
    }
    input[type="time"]::-webkit-datetime-edit {
        line-height: 1;
        padding: 0;
        margin-bottom: -4px;
    }
`;
